import { render, staticRenderFns } from "./avaliacoes-externas.vue?vue&type=template&id=3f6f430c"
import script from "./avaliacoes-externas.vue?vue&type=script&lang=js"
export * from "./avaliacoes-externas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports